import { localizedRoutes, type RouteKey } from '@/i18n/routes'
import type { SupportedLanguage } from '@/i18n'

export const TREATMENT_SLUGS: Record<
  SupportedLanguage,
  Record<string, RouteKey>
> = {
  it: {
    // Chirurgia estetica seno
    'mastoplastica-additiva-verona': 'breastSurgery',
    'mastoplastica-riduttiva-verona': 'breastSurgery',
    'mastopessi-verona': 'breastSurgery',
    'ginecomastia-verona': 'breastSurgery',
    'capezzolo-introflesso-verona': 'breastSurgery',
    // Chirurgia estetica corpo
    'liposuzione-verona': 'bodySurgery',
    'addominoplastica-verona': 'bodySurgery',
    'lifting-braccia-verona': 'bodySurgery',
    'rimodellamento-glutei-verona': 'bodySurgery',
    'chirurgia-intima-verona': 'bodySurgery',
    'bodytite-verona': 'bodySurgery',
    'quantumrf-verona': 'bodySurgery',
    // Chirurgia estetica viso
    'blefaroplastica-verona': 'faceSurgery',
    'rinoplastica-verona': 'faceSurgery',
    'otoplastica-verona': 'faceSurgery',
    'lifting-viso-verona': 'faceSurgery',
    // Medicina estetica corpo
    'iperidrosi-verona': 'bodyAesthetic',
    'carbossiterapia-verona': 'bodyAesthetic',
    'biostimolazione-corpo-verona': 'bodyAesthetic',
    // Medicina estetica viso
    'filler-verona': 'faceAesthetic',
    'botox-verona': 'faceAesthetic',
    'biostimolazione-viso-verona': 'faceAesthetic',
    'fili-di-trazione-verona': 'faceAesthetic',
    'peeling-chimico-verona': 'faceAesthetic',
    'radiesse-verona': 'faceAesthetic',
    'iperpigmentazione-viso-verona': 'faceAesthetic',
    'ringiovanimento-viso-e-collo-verona': 'faceAesthetic',
    // Medicina rigenerativa
    'lifting-cellule-staminali-verona': 'regenerative',
    'ringiovanimento-cutaneo-verona': 'regenerative',
    'julaine-verona': 'regenerative',
    'harmonica-verona': 'regenerative',
    // Trattamenti laser
    'epilazione-permanente-verona': 'laser',
    'laser-co2-verona': 'laser',
    'iperpigmentazione-verona': 'laser',
  },
  en: {
    // Breast surgery
    'breast-augmentation': 'breastSurgery',
    'breast-reduction': 'breastSurgery',
    'breast-lift': 'breastSurgery',
    'gynecomastia': 'breastSurgery',
    'inverted-nipple': 'breastSurgery',
    // Body surgery
    'liposuction': 'bodySurgery',
    'abdominoplasty': 'bodySurgery',
    'arm-lift': 'bodySurgery',
    'buttock-augmentation': 'bodySurgery',
    'intimate-surgery': 'bodySurgery',
    'bodytite': 'bodySurgery',
    'quantumrf': 'bodySurgery',
    // Face surgery
    'blepharoplasty': 'faceSurgery',
    'rhinoplasty': 'faceSurgery',
    'otoplasty': 'faceSurgery',
    'facelift': 'faceSurgery',
    // Body aesthetic medicine
    'hyperhidrosis': 'bodyAesthetic',
    'carboxytherapy': 'bodyAesthetic',
    'body-biostimulation': 'bodyAesthetic',
    // Face aesthetic medicine
    'fillers': 'faceAesthetic',
    'botox': 'faceAesthetic',
    'face-biostimulation': 'faceAesthetic',
    'thread-lift': 'faceAesthetic',
    'chemical-peel': 'faceAesthetic',
    'radiesse': 'faceAesthetic',
    'facial-hyperpigmentation': 'faceAesthetic',
    'face-neck-rejuvenation': 'faceAesthetic',
    // Regenerative medicine
    'stem-cell-lifting': 'regenerative',
    'skin-rejuvenation': 'regenerative',
    'julaine': 'regenerative',
    'harmonica': 'regenerative',
    // Laser treatments
    'permanent-hair-removal': 'laser',
    'co2-laser': 'laser',
    'hyperpigmentation': 'laser',
  },
}

export function getCategoryKeyFromTreatmentSlug(
  slug: string,
  lang: SupportedLanguage
): RouteKey | null {
  return TREATMENT_SLUGS[lang][slug] || null
}

export function getCategoryKeyFromCategorySlug(
  categorySlug: string,
  lang: SupportedLanguage
): RouteKey | null {
  const entry = Object.entries(localizedRoutes).find(
    ([, paths]) => paths[lang] === categorySlug
  )
  return (entry?.[0] as RouteKey) || null
}

export function getTreatmentPath(
  categoryKey: RouteKey,
  treatmentSlug: string,
  lang: SupportedLanguage
): string {
  const categorySlug = localizedRoutes[categoryKey][lang]
  return `/${lang}/${categorySlug}/${treatmentSlug}`
}

export function getAllTreatmentSlugs(lang: SupportedLanguage): string[] {
  return Object.keys(TREATMENT_SLUGS[lang])
}
